import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  meta: {},
  sessions: {
    // [sessionId]: Session
  },
}

const getSessionId = (session) => session.sessionId

const slice = createSlice({
  name: 'sessions',
  initialState: defaultState,
  reducers: {
    putSession: (state, action) => {
      const { session } = action.payload
      state.sessions[getSessionId(session)] = session
    },
    putSessions: (state, action) => {
      const { sessions } = action.payload
      sessions.paginated.forEach((session) => {
        state.sessions[getSessionId(session)] = session
      })
    },
    clearSession: (state, action) => {
      const { sessionId } = action.payload
      delete state.sessions[sessionId]
    },
    clearSessions: (state) => {
      state.sessions = { ...defaultState.sessions }
    },
  },
})

const { actions, reducer } = slice

export const { putSession, putSessions, clearSession, clearSessions } = actions

export default reducer
